import { logAnalytics } from 'shared/middlewares/analytics/logger';
import {
  secondaryMarketLiveInstantBookWorkflowAborted,
  secondaryMarketLiveInstantBookWorkflowCompleted,
  secondaryMarketLiveInstantBookWorkflowFailed,
  secondaryMarketLiveInstantBookWorkflowInit,
  secondaryMarketLiveInstantBookWorkflowRejected,
  secondaryMarketLiveInstantBookWorkflowRequested,
} from 'state/secondaryMarket/live/instantBook/instantBook.actions';
import type { Thunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage, isServerError } from 'utils/http/httpClient.model';

export function secondaryMarketLiveInstantBookWorkflowInitThunk(orderId: string): Thunk<void> {
  return dispatch => {
    logAnalytics.trackEvent('Secondary market', 'Instant book workflow initiated');
    dispatch(secondaryMarketLiveInstantBookWorkflowInit(orderId));
  };
}

export function secondaryMarketLiveInstantBookWorkflowAbortedThunk(orderId: string): Thunk<void> {
  return dispatch => {
    logAnalytics.trackEvent('Secondary market', 'Instant book workflow aborted');
    dispatch(secondaryMarketLiveInstantBookWorkflowAborted(orderId));
  };
}

export function secondaryMarketLiveInstantBookWorkflowCompletedThunk(orderId: string): Thunk<void> {
  return dispatch => {
    logAnalytics.trackEvent('Secondary market', 'Instant book workflow completed');
    dispatch(secondaryMarketLiveInstantBookWorkflowCompleted(orderId));
  };
}

export function secondaryMarketLiveInstantBookRequestedThunk(orderId: string): Thunk<void> {
  return dispatch => {
    logAnalytics.trackEvent('Secondary market', 'Instant book workflow requested');
    dispatch(secondaryMarketLiveInstantBookWorkflowRequested(orderId));
  };
}

export function liveInstantBookErrorsThunk(orderId: string, error?: HttpError): Thunk<void> {
  return dispatch => {
    const message = extractHttpErrorMessage(error);
    if (isServerError(error)) {
      dispatch(secondaryMarketLiveInstantBookWorkflowFailed(orderId, message));
    } else {
      dispatch(secondaryMarketLiveInstantBookWorkflowRejected(orderId, message));
    }
  };
}
